import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_CRYPTO_SECRET_KEY || "";
export default class StorageGateway {
  static async set(key, value) {
    try {
      // Convert to string if it’s an object
      const data = typeof value === "string" ? value : JSON.stringify(value);

      // Encrypt data
      const encryptedData = CryptoJS.AES.encrypt(data, SECRET_KEY).toString();

      localStorage.setItem(key, encryptedData);
    } catch (ex) {
      console.error("Storage set error:", ex);
    }
  }

  static get(key) {
    try {
      const encryptedData = localStorage.getItem(key);
      if (!encryptedData) return null;

      // Decrypt data
      const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

        return decryptedData;
    } catch (ex) {
      console.error("Storage get error:", ex);
      return null;
    }
  }

  static remove(key) {
    try {
      localStorage.removeItem(key);
    } catch (ex) {
      console.error("Storage remove error:", ex);
    }
  }
}
